<template>
    <PickBackground objectKey="gr_detail" type="good_receive"/>
</template>

<script>
import PickBackground from '@/views/pick/Background.vue';

export default {
    components:{
        PickBackground
    },
}
</script>